import {
  HiddenInput,
  UploadIcon,
  UploadLabel,
  UploadPreview,
  UploadSlot,
  EditButton,
  ButtonWrapper,
  ErrorText,
} from "./PhotoUploadBoxStyles";

import Upload from "../../img/logged/upload.png";
import { PhotoUploadBoxProps } from "../../types/componentsConstructors";
import { useState, useRef } from "react";
import ImageCropModal from "../imageCropModal/ImageCropModal";

const MAX_FILE_SIZE = 2 * 1024 * 1024;

const PhotoUploadBox: React.FC<PhotoUploadBoxProps> = ({
  label,
  index,
  preview,
  onChange,
}) => {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [lastOriginalImage, setLastOriginalImage] = useState<string | null>(
    null
  );
  const [error, setError] = useState<string | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (file: File | null) => {
    if (!file) return;

    if (file.size > MAX_FILE_SIZE) {
      setError("Imagem muito pesada. Tente uma com até 2MB.");
      return;
    }

    setError(null);

    const reader = new FileReader();
    reader.onloadend = () => {
      const result = reader.result as string;
      setSelectedImage(result);
      setLastOriginalImage(result);
    };
    reader.readAsDataURL(file);

    if (inputRef.current) {
      inputRef.current.value = "";
    }
  };

  const handleCropComplete = (cropped: string) => {
    const croppedFile = dataURLToFile(cropped, `image-${index}.jpg`);
    onChange(index, croppedFile);
    setSelectedImage(null);
  };

  const openCropModalFromPreview = () => {
    if (lastOriginalImage) {
      setSelectedImage(lastOriginalImage);
    }
  };

  const handleRemove = () => {
    onChange(index, null);
    setLastOriginalImage(null);
    setError(null);
  };

  return (
    <>
      <UploadSlot>
        <UploadLabel>{label}</UploadLabel>

        <HiddenInput
          ref={inputRef}
          type="file"
          accept="image/*"
          onChange={(e) => handleFileChange(e.target.files?.[0] || null)}
        />

        {preview ? (
          <>
            <UploadPreview src={preview} alt={`preview-${index}`} />
            <ButtonWrapper>
              <EditButton onClick={openCropModalFromPreview}>Editar</EditButton>
              <EditButton onClick={handleRemove}>Remover</EditButton>
            </ButtonWrapper>
          </>
        ) : (
          <UploadIcon src={Upload} alt="upload" />
        )}

        {error && <ErrorText>{error}</ErrorText>}
      </UploadSlot>

      {selectedImage && (
        <ImageCropModal
          imageSrc={selectedImage}
          onClose={() => setSelectedImage(null)}
          onCropComplete={handleCropComplete}
        />
      )}
    </>
  );
};

export default PhotoUploadBox;

function dataURLToFile(dataUrl: string, filename: string): File {
  const arr = dataUrl.split(",");
  const mime = arr[0].match(/:(.*?);/)?.[1] || "";
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}
